module.exports = __webpack_public_path__ + "img/data_box_custom.e2b24219.png";